export const HOST = ['https://stock-qa.qa.tigerbrokers.net', 'https://hq.tradeup.com'];

export const API = {
    /**
     * 查标的的行情接口
     * https://tigertech.feishu.cn/wiki/wikcnfpGBi0zhvrdnyxw275vePh 参考1.13.10
     * https://apidocs.tigerfintech.com/repository/98/api/qa1739174413081/%E6%90%9C%E7%B4%A2%E6%8E%A5%E5%8F%A3.json#/operations/suggest-v13-GET
     */
    search: '/suggest/v13'
};

export function bindCG() {
    const cfg = CG_API.quote?.COMMON;

    if (cfg) {
        HOST.fill(cfg);
    }
}
